module.exports = __webpack_public_path__ + "img/400x600.9f34760c.gif";